import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import trunk from './configureStore'
import './index.css'
import { dismissIdentitySplash } from './utils/identitySplash'

const root = document.getElementById('root')

// WARP-567 — the identity-switch splash is shown by index.html while this boots.
// `dismissIdentitySplash` waits for the app to actually paint before fading it out, and
// clears the stash unconditionally so an ordinary load never inherits a stale splash
// left behind by an interrupted swap.
trunk.init().then(() => {
  ReactDOM.createRoot(root).render(<App />)
  dismissIdentitySplash()
})
